export * from './kunde-detail.component';
export * from './kunde-detail.component.module';